import { canAccessAdmin, canAccessLearner } from '@/utils/roleUtils'

export type LoginEntry = 'learner' | 'admin'

/**
 * 로그인 성공 또는 인증된 사용자의 로그인 URL 재방문 시 도착지를 결정.
 *
 * 정책:
 *  - 진입 페이지 권한이 있으면 그쪽으로 (사용자 의도 존중)
 *  - 진입 페이지 권한이 없고 반대쪽 권한이 있으면 자동 교정
 *  - 둘 다 없으면 해당 로그인 페이지로 (안전 fallback)
 */
export function resolvePostLoginPath(
  role: string | undefined,
  entry: LoginEntry,
): string {
  const admin = canAccessAdmin(role)
  const learner = canAccessLearner(role)

  if (entry === 'learner') {
    if (learner) return '/my'
    if (admin) return '/admin'
    return '/login'
  }
  // entry === 'admin'
  if (admin) return '/admin'
  if (learner) return '/my'
  return '/admin/login'
}
